import { RecipientTypeEnum } from "../../common/enums/RecipientTypeEnum";
import { IEditDTO, IRecipientDTO, IReferenceDTO } from "../../services/notification-list-data-service/Models";
import { IFormUserRecipient, IFormRecipient, RecipientsFormType } from "../form-recipient-list/FormRecipientListUtils";


export enum NotificationListAdminMode {
    Add = 0,
    Edit = 1
}


export type NotificationListFormType = {
    


} & RecipientsFormType & IEditDTO;
//} & Omit<IEditDTO, 'recipients'>

export const defaultFormValues: NotificationListFormType = {
    id: -1,
    name: '',
    userRecipients: [],

    recipients: []
};

export type NotificationListEditorDialogInitValues = {
    groupID: number;
    organizationID: number;
    notificationListID: number;

    recipientType?: RecipientTypeEnum;
};

export type NotificationListEditorDialogResultValues = {
    notificationList: IEditDTO | undefined;
};


export const radioButtons=[{
    label: 'All',
    ariaLabel: "all recipient types",
    value: RecipientTypeEnum.Invalid
},{
    label: RecipientTypeEnum[RecipientTypeEnum.Email],
    ariaLabel: "email",
    value: RecipientTypeEnum.Email
},{
    label: RecipientTypeEnum[RecipientTypeEnum.Text],
    ariaLabel: "text",
    value: RecipientTypeEnum.Text
},{
    label: RecipientTypeEnum[RecipientTypeEnum.Voice],
    ariaLabel: "voice",
    value: RecipientTypeEnum.Voice
}];


const NotificationListEditorUtils = {

    mapToForm: (model: IEditDTO, 
        referenceData: IReferenceDTO,
        allowVoiceAlarm: boolean) : NotificationListFormType => {

        const formValues: NotificationListFormType  = {
            ...model,
            userRecipients: []
        };

        // include disabled recipients when editing 
        referenceData.users.filter(o => o.id > 0 &&  ((!o.isDisabled && o.id > 0) || model.id > 0))
            .forEach(o => {
            const userRecipient: IFormUserRecipient = {
                userID: o.id,
                userName: o.name,
                disabled: o.isDisabled,
                recipients: referenceData.recipients.filter(v => 
                                                //v.organizationID === model.organizationID &&
                                                v.userID === o.id && 
                                            (allowVoiceAlarm || v.type !== RecipientTypeEnum.Voice))
                            .map(v => {

                                const selectedRecipient = model.recipients.find(x => x.id === v.id);

                                const recipient: IFormRecipient = {
                                    id: v.id,
                                    recipientType: v.type,
                                    recipientSubType: v.subType,
                                    to: v.to,
                                    organizationID: v.organizationID,
                                    selected: selectedRecipient !== undefined
                                }

                                return recipient;
                            })
                            .sort((a, b) => a.to.toLowerCase().localeCompare(b.to.toLowerCase()))
            };

            if (userRecipient.recipients.length > 0) {
                formValues.userRecipients.push(userRecipient);
            }
        });

        return formValues;
    },

    mapToModel: (formData: NotificationListFormType): IEditDTO => {

        const model: IEditDTO = {
            id: formData.id,
            name: formData.name,
            recipients: []
        };

        let recipients: IRecipientDTO[] = [];
        formData.userRecipients.filter(o => o.recipients.find(v => v.selected))
        .forEach(o => {
            recipients = recipients.concat(o.recipients.filter(v => v.selected)
                        .map(v => {
                            const item: IRecipientDTO = {
                                organizationID: v.organizationID,
                                userID: o.userID,
                                id: v.id,
                                isDisabled: false
                            };

                            return item;
                        }));
        });

        model.recipients = recipients;

        return model;
    }
}


export default NotificationListEditorUtils;